import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

interface Choice<T> {
  value: T;
  label: React.ReactNode;
  ariaLabel: string;
}

const DropdownMenuItemContentRadio = <T extends string>({
  name,
  value,
  onChange,
  choices,
  children,
}: {
  name: string;
  value: T;
  onChange: (value: T) => void;
  choices: Choice<T>[];
  children: React.ReactNode;
}) => (
  <DropdownMenuPrimitive.RadioGroup
    value={value}
    onValueChange={(v) => onChange(v as T)}
  >
    <DropdownMenuPrimitive.Label className="dropdown-menu-group-title">
      {children}
    </DropdownMenuPrimitive.Label>
    {choices.map((choice) => (
      <DropdownMenuPrimitive.RadioItem
        key={String(choice.value)}
        value={choice.value}
        onSelect={(e) => e.preventDefault()}
        aria-label={choice.ariaLabel}
        className="dropdown-menu-item dropdown-menu-item-base"
      >
        <span className="dropdown-menu-item__icon">{choice.label}</span>
        <span className="dropdown-menu-item__text">
          {choice.ariaLabel.split(" - ")[0]}
        </span>
      </DropdownMenuPrimitive.RadioItem>
    ))}
  </DropdownMenuPrimitive.RadioGroup>
);

DropdownMenuItemContentRadio.displayName = "DropdownMenuItemContentRadio";

export default DropdownMenuItemContentRadio;
